import { WHISPERING_FOREST_PORTAL_RETURN_SPAWN } from "../../../@shared/utils/voidCityStoryPortalSpawns";
import { WHISPERING_FOREST_VOID_CAVE_RETURN_SPAWN } from "../whisperingForest/whisperingForestMapConfig";

export const resolveVoidCaveExitRoute = (entryData = {}) => ({
  sceneKey: "WhisperingForestScene",
  spawn: WHISPERING_FOREST_VOID_CAVE_RETURN_SPAWN,
  cityReturnSpawn:
    entryData.cityReturnSpawn ||
    entryData.returnSpawn ||
    WHISPERING_FOREST_PORTAL_RETURN_SPAWN,
  doorLabel: "Return To Whispering Forest",
});
